
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import { debounce, property, throttle } from "lodash";
export default {
  props: ["item"],
  components: {
    CoolLightBox,
  },
  data() {
    return {
      related: [],
      combo: [],
      comboTotal: 0,
      showPriceHistory: false,
      index: null,
      mobileChinHide: false,
      activeIndex: 0,
      expanded: {
        needs: this.item.flat_tags.needs || this.item.flat_tags.Ανάγκη,
        description: this.item.comment,
      },
      heights: {},
      scrolled: false,
      fomoTime: "",
      promos: [],
      group: [],
    };
  },
  async mounted() {
    if (process.browser) {
      if (this.item.availability && this.item.availability.noCart) {
        this.getRelated();
      } else {
        this.getCombo();
      }
      this.calculateHeight("#description");
      this.calculateHeight("#usage");
      this.calculateHeight("#reviews");
      this.calculateHeight("#availability");
      this.calculateHeight("#needs");
      if (this.$route.hash === "#reviews" && this.item.rating_count) {
        this.$nextTick(() => this.openReviews());
      }
      let self = this;
      if (window.pageYOffset > 85) {
        self.scrolled = true;
      }
      window.addEventListener("scroll", function (e) {
        if (window.pageYOffset > 85) {
          self.scrolled = true;
        } else {
          self.scrolled = false;
        }
      });
      this.fomo();
      if (this.item.group) {
        this.getGroup();
      }
      let draggables = document.querySelectorAll(".dragster") || [];
      for (const slider of draggables) {
        if (slider) {
          const preventClick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
          };
          let isDown = false;
          let isDragged = false;
          let startX;
          let scrollLeft;

          slider.addEventListener("mousedown", (e) => {
            isDown = true;
            slider.classList.add("active");
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
          });
          slider.addEventListener("mouseleave", () => {
            isDown = false;
            slider.classList.remove("active");
          });
          slider.addEventListener("mouseup", (e) => {
            isDown = false;
            const elements = document.querySelectorAll("a");
            if (isDragged) {
              for (let i = 0; i < elements.length; i++) {
                elements[i].addEventListener("click", preventClick);
              }
            } else {
              for (let i = 0; i < elements.length; i++) {
                elements[i].removeEventListener("click", preventClick);
              }
            }
            slider.classList.remove("active");
            isDragged = false;
          });
          slider.addEventListener(
            "mousemove",
            throttle((e) => {
              if (!isDown) return;
              isDragged = true;
              e.preventDefault();
              const x = e.pageX - slider.offsetLeft;
              const walk = (x - startX) * 2;
              slider.scrollLeft = scrollLeft - walk;
            }),
            10
          );
        }
      }
    }
    try {
      this.promos = await this.$hyperItem.promos(this.item, "smartbuy");
    } catch (e) {}
  },
  methods: {
    openReviews() {
      this.$hyperUtility.vSet(this.expanded, "reviews", true);
      this.$nextTick(() => {
        this.calculateHeight("#reviews");
        this.$hyperUtility.scrollTo("#reviews");
      });
    },
    addCombo() {
      this.$hyperCart.addFromBarcodes(
        this.combo.map((i) => i.barcode),
        true,false
      );
    },
    async getCombo() {
      try {
        let data = await this.$cms.get({
          title: "combo_items",
          store_id: this.$store.getters.store.id,
          limit: 1000,
          q: this.item.barcode + ":",
        });
        let barcodes = null;
        if (data) {
          barcodes = data?.docs[0]?.value;
        }
        console.log(barcodes);
        if (barcodes && barcodes.length) {
          barcodes = barcodes.split(":")[1];
          let data = await this.$hyperItem.getItems(
            `barcodes=${barcodes}&limit=10`
          );
          console.log(data);
          if (data.items?.docs) {
            console.log(data.items.docs);
            let prepared = (
              await this.$hyperItem.prepareItems(data.items.docs)
            ).filter((i) => i.availability && !i.availability.noCart);
            if (prepared?.length) {
              // #22610 — the combo is a 2-item "frequently bought together" pair
              // (heading + the "Αγορά και των 2" button). It was spreading the
              // WHOLE similar-products list (combo_items = same source as
              // related_items, up to 10 barcodes from SimilarProducts.xlsx), so a
              // pair became up to 11 items with a wrong total. Cap to main + top partner.
              this.combo = [this.item, prepared[0]];
              this.comboTotal = this.combo.reduce((a, b) => {
                return a + this.$hyperItem.actualPrice(b);
              }, 0);
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getRelated() {
      try {
        //get from cms and table related_items filter by barcode and store_id
        let data = await this.$cms.get({
          title: "related_items",
          store_id: this.$store.getters.store.id,
          limit: 1000,
          q: this.item.barcode + ":",
        });
        let barcodes = null;
        if (data) {
          barcodes = data?.docs[0]?.value;
        }
        console.log(barcodes);
        if (barcodes && barcodes.length) {
          barcodes = barcodes.split(":")[1];
          let data = await this.$hyperItem.getItems(
            `barcodes=${barcodes}&limit=10`
          );
          console.log(data);
          if (data.items?.docs) {
            console.log(data.items.docs);
            let prepared = await this.$hyperItem.prepareItems(data.items.docs);
            if (
              prepared.filter((i) => i.availability && !i.availability.noCart)
                .length > 3
            ) {
              this.related = prepared.filter(
                (i) => i.availability && !i.availability.noCart
              );
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async notifyWhenAvailable() {
      if (process.browser) {
        let emailInput = document.querySelector("#notifyEmail");
        let a = await this.$hyperItem.notifyWhenAvailable(
          this.item,
          emailInput.value
        );
        if (a) {
          emailInput.value = "";
          emailInput.parentElement.style.opacity = 0.5;
          emailInput.parentElement.style.pointerEvents = "none";
        }
      }
    },
    async getGroup() {
      if (this.item.group) {
        let temp = await this.$axios.$get(
          `${process.env.axiosUrl}/items/store/${this.$store.getters.store._id}?store_id=${this.$store.getters.store._id}&group=${this.item.group}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        );
        if (temp.items && temp.items.docs) {
          try {
            this.group = await this.$hyperItem.prepareItems(temp.items.docs);
          } catch (error) {}
        }
      }
    },
    fomo() {
      let self = this;
      let dd = new Date();
      if (
        dd.getDay() == 0 ||
        dd.getDay() == 6 ||
        (dd.getDay() == 5 && dd.getHours() >= 12)
      ) {
        return;
      }
      let fomoTimer = setInterval(() => {
        let d = new Date();
        d.setHours(14);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        let timeTo = this.$hyperUtility.timeTo(d, true);
        if (!timeTo) {
          clearInterval(fomoTimer);
          return;
        }
        if (timeTo.days) {
          timeTo.hours += timeTo.days * 24;
        }
        self.fomoTime = `${timeTo.hours ? `${timeTo.hours} ώρες ` : ``}${
          timeTo.minutes
        } λεπτά και ${timeTo.seconds} δευτερόλεπτα`;
      }, 1000);
    },
    async calculateHeight(selector) {
      if (process.browser) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        let el = document.querySelector(`${selector} .content`);
        if (!el) {
          return;
        }
        this.$hyperUtility.vSet(
          this.heights,
          `dom${selector.replace(/\#|\./g, "")}`,
          el.scrollHeight
        );
        let self = this;
        window.addEventListener("resize", (_) => {
          self.$hyperUtility.vSet(
            this.heights,
            `dom${selector.replace(/\#|\./g, "")}`,
            el.scrollHeight
          );
        });
      }
    },
    setVariation(io, value, index) {
      if (!value) {
        delete io.selected;
      } else {
        io.selected = value;
      }
      let variations = this.item.variation;
      if (variations) {
        let found = -1;
        variations.forEach((v, vindex) => {
          if (v && v.key == io.key) {
            found = vindex;
          }
        });
        if (found == -1 && value) {
          variations.push({ ...(value || {}) });
        } else {
          if (!value) {
            delete variations[found];
          } else {
            variations[found] = value;
          }
        }
      } else if (value) {
        variations = [{ ...(value || {}) }];
      }
      let tempItems = this.$hyperCart.getCart().items.filter((i) => {
        if (
          JSON.stringify(i.variation) == JSON.stringify(variations) &&
          this.item._id == i._id
        ) {
          return i;
        }
      }).length;
      if (variations && variations[0] == null) {
        delete this.item.variation;
      } else {
        this.item.variation = variations;
      }
      let required = [];
      this.item.options.forEach((o) => {
        if (o.required) {
          required.push(o.key);
        }
      });
      if (this.item.variation) {
        this.item.variation.forEach((v) => {
          if (required.includes(v.key)) {
            required.splice(required.indexOf(v.key), 1);
          }
        });
      }
      this.item.required = required;
      this.item.prices.actual_price = this.$hyperItem
        .actualPrice(this.item)
        .toFixed(2);
      this.inCart = tempItems;
      this.$store.commit("item", this.item);
      this.$forceUpdate();
    },
  },
};
